module.exports = __webpack_public_path__ + "img/shutterstock_244190287@2x.d4b1df40.png";